import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { PagedResults, PagingParams } from "@abaco/web-common/src/Paging";
import {
    LinkExecution,
    ActivityLinkPagedResults,
    ActivityLinkPagination,
    LinkExecutionOut
} from "../models/ActivityLink";

export default class ActivityLinkApi {
    private http: HTTPClient;
    private rootPath: string;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath;
    }

    public async getLinkExecutions(
        subjectId: number,
        date: Date,
        plotId: number,
        blockId: number | null,
        paging: ActivityLinkPagination
    ): Promise<ActivityLinkPagedResults<LinkExecution>> {
        const startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
        const endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
        const res = await this.http.get(
            `/execution-time-tracker/api/v1/ett/subjects/${subjectId}/executions/toAssociate`,
            {
                params: {
                    nextKey: paging.nextKey,
                    pageSize: paging.pageSize,
                    fromStartDate: startDate.getTime(),
                    toStartDate: endDate.getTime(),
                    plotId: plotId,
                    blockId: blockId ? blockId : undefined
                }
            }
        );
        return res.data;
    }

    public async getAllLinkExecutions(
        subjectId: number,
        date: Date,
        plotId: number,
        blockId: number | null
    ): Promise<LinkExecution[]> {
        const paging: ActivityLinkPagination = {
            nextKey: 0,
            pageSize: 300
        };
        let res: LinkExecution[] = [];
        let page: ActivityLinkPagedResults<LinkExecution>;
        do {
            page = await this.getLinkExecutions(subjectId, date, plotId, blockId, paging);
            res = res.concat(page.records);
            paging.nextKey = page.nextKey;
        } while (page.nextKey);
        return res;
    }

    public async updateLinkExecution(subjectId: number, pkId: number, form: LinkExecutionOut): Promise<LinkExecution> {
        const res = await this.http.put(
            `/execution-time-tracker/api/v1/ett/subjects/${subjectId}/executions/${pkId}`,
            form
        );
        return res.data;
    }

    public async canLinkActivities(pkCuaa: number) {
        const res = await this.http.get(
            `/sitiagri-rest-api/api_basic/v1/user_registry/module_competencies/BEST_PRACTICE/ETT_LINK_ACTIVITY`,
            {
                params: {
                    subject_id: pkCuaa
                }
            }
        );
        return res.data.result;
    }
}
